// One Astryx theme per studio, generated at runtime from the accent stored in
// the database (studio branding is data, so it cannot be built ahead of time).
// The HCT palette generator derives on-accent, hover and pressed tokens with
// guaranteed contrast; we only pin the black canvas the brand calls for.
import { defineTheme } from '@astryxdesign/core/theme';
import { neutralTheme } from '@astryxdesign/theme-neutral/built';

const cache = new Map<string, ReturnType<typeof defineTheme>>();

export function tenantTheme(slug: string, accent: string) {
  const id = `${slug}:${accent}`;
  let theme = cache.get(id);
  if (!theme) {
    theme = defineTheme({
      name: `sgx-${slug}`,
      extends: neutralTheme,
      color: { accent: [accent, accent], neutralStyle: 'cool', contrast: 'high' },
      typography: {
        scale: { base: 16, ratio: 1.2 },
        body: { family: 'Inter', fallbacks: '-apple-system, system-ui, "Segoe UI", Roboto, sans-serif' },
        heading: { weight: 'bold', weights: { 1: 'bold', 2: 'bold' } },
      },
      radius: { base: 4, multiplier: 2 },
      tokens: {
        // brand canvas: black page, near-black raised surfaces, white text
        '--color-background-body': ['#000000', '#000000'],
        '--color-background-surface': ['#0E0F12', '#0E0F12'],
        '--color-background-card': ['#121317', '#121317'],
        '--color-background-popover': ['#16171C', '#16171C'],
        '--color-text-primary': ['#FFFFFF', '#FFFFFF'],
      },
      components: {
        button: { base: { borderRadius: 'var(--radius-full)', fontWeight: 'var(--font-weight-semibold)' } },
        card: { base: { borderRadius: 'var(--radius-container)' } },
      },
    });
    cache.set(id, theme);
  }
  return theme;
}

/** Fallback before the studio profile has loaded. */
export const bootTheme = () => tenantTheme('boot', '#4690FF');
